// extracted by mini-css-extract-plugin
module.exports = {"content":"_26NQ_","header":"w1S2k","headerText":"_3PWgH","chip":"_1bBSS","rune":"_26sbY","icon":"uFZtG","item":"_2zlEl","itemFull":"XIAk8","properties":"_3TFoC","brew":"_1BBn4"};